import $ from 'jquery';

import initSelectionButton from './angle/custom/selection_button.js';
import initCollapseControl from './angle/modules/common/collapse_control.js';
import initDatatables from './angle/modules/tables/datatable';
import initSweetAlert from './angle/modules/elements/sweetalert';
import init_qrcode_reader from './angle/custom/qrcode_reader';
  
$(function() {
  // select tap button
  initSelectionButton();
  // collapse/expand
  initCollapseControl();
  // datatable
	initDatatables();
	// sweet alert
  initSweetAlert();  
  init_qrcode_reader();  
  
  // let scanner = new Instascan.Scanner({ video: document.getElementById('video') }); // 映像の出力先を指定
  // scanner.addListener('scan', function (content) {
  //   alert(content); // 読み込み後の処理
  // });
  // Instascan.Camera.getCameras().then(function (cameras) {
  //   if (cameras.length > 0) {
  //     scanner.start(cameras[0]); // 0番目のカメラを指定
  //   } else {
  //     alert('カメラが見つかりませんでした');
  //   }
  // }).catch(function (e) {
  //   console.error(e);
  //   alert('カメラの起動に失敗しました');
  // });
  /*
   Copyright 2011 Lazar Laszlo (lazarsoft@gmail.com, www.lazarsoft.info)
   
   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at
	   http://www.apache.org/licenses/LICENSE-2.0
   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
*/
  $('.edit_order').on('change', '.identity', function(event) {
    var selected = $(this).children('option:selected');
    var row = $(this).parents('tr');
    var fee_field = row.find('input.fee');
    var fee = selected.attr('data-fee');
    fee_field.val(fee);
    fee_field.trigger('change');
  });

});

